import SkillsSection from '../Skills';

function Skills() {
  return (
    <div id="skills">
      <SkillsSection />
    </div>
  );
}

export default Skills;
